"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContextProvider = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var useWebAnalytics_1 = require("../hooks/useWebAnalytics");
var logger_1 = require("../utils/logger");
var APP_CONTEXT_API = 'react-app-context-provider';
// eslint-disable-next-line @typescript-eslint/naming-convention
function AppContextProvider(_a) {
    var ids = _a.ids, fields = _a.fields, children = _a.children;
    var webAnalytics = (0, useWebAnalytics_1.useWebAnalytics)();
    (0, react_2.useEffect)(function () {
        if (webAnalytics) {
            webAnalytics.appContext(ids, __assign(__assign({}, fields), { app_context_api: APP_CONTEXT_API }));
        }
        else {
            var errorMessage = "Cannot set App Context for app ".concat(JSON.stringify(ids, null, 2), ". Please ensure the component is wrapped with WebAnalyticsProvider and the webAnalytics is NOT undefined\n            \nFor details on how to fix it, please refer to https://gitlab.agodadev.io/full-stack/fe-data/analytics-data-acquisition/-/tree/master/packages/analytics-data-acquisition-react?ref_type=heads#how-to-fix-cannot-observe-eventelement-for-please-ensure-the-component-is-wrapped-with-webanalyticsprovider-and-the-webanalytics-is-not-undefined-error");
            (0, logger_1.logError)(errorMessage);
        }
    }, [fields]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
}
exports.AppContextProvider = AppContextProvider;
